import { render, staticRenderFns } from "./YtVideoPopup.vue?vue&type=template&id=dcc0e28e&scoped=true&"
import script from "./YtVideoPopup.vue?vue&type=script&lang=js&"
export * from "./YtVideoPopup.vue?vue&type=script&lang=js&"
import style0 from "./YtVideoPopup.vue?vue&type=style&index=0&id=dcc0e28e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dcc0e28e",
  null
  
)

export default component.exports